import * as React from "react";
import { Pressable, Text, View } from "react-native";
import { Feather } from "@expo/vector-icons";

import { Modal } from "~/components/AccountActions/modal.web";
import { CollectionForm } from "~/components/CollectionForm";
import { useAccountStore } from "~/stores/space";
import { ListContainer, ListItem } from "~/ui/List";

export type CollectionDialogStepType =
  | { step: "selectSpace" }
  | {
      step: "form";
      props: {
        spaceId: string;
        collectionId?: string;
      };
    };

export function CollectionDialog({
  onDismiss,
  step,
}: {
  onDismiss: () => void;
  step?: CollectionDialogStepType;
}) {
  const [steps, setSteps] = React.useState<Array<CollectionDialogStepType>>(
    step ? [step] : [{ step: "selectSpace" }],
  );

  const { store: account } = useAccountStore();
  const currentStep = steps.at(-1)!;

  return (
    <Modal
      header={
        currentStep.step === "form" ? (
          <Pressable
            onPressIn={() => {
              setSteps([
                {
                  step: "selectSpace",
                },
              ]);
            }}
            className="grow-0 flex-row items-center gap-2"
            role="button"
            aria-label="go back"
          >
            <Feather name="arrow-left" className="text-white" size={18} />
            <Text className="text-white">Back</Text>
          </Pressable>
        ) : null
      }
      onDismiss={onDismiss}
    >
      {() => {
        switch (currentStep.step) {
          case "selectSpace": {
            return (
              <View className="gap-y-4">
                {account.spaces.size > 0 && (
                  <ListContainer title="Select a space to proceed">
                    {account.spacesAsArrayWithoutBacklog.map((space) => (
                      <ListItem key={space.id} asChild>
                        <Pressable
                          onPress={() => {
                            setSteps((curr) =>
                              curr.concat({
                                step: "form",
                                props: {
                                  spaceId: space.id,
                                },
                              }),
                            );
                          }}
                          className={"flex-row"}
                        >
                          <View className="flex-row items-center">
                            <Text className="text-base text-white">
                              {space.displayName ?? space.slug}
                            </Text>
                          </View>
                        </Pressable>
                      </ListItem>
                    ))}
                  </ListContainer>
                )}
              </View>
            );
          }

          case "form": {
            return (
              <CollectionForm
                spaceId={currentStep.props.spaceId}
                collectionId={currentStep.props.collectionId}
                onSuccess={onDismiss}
              />
            );
          }

          default:
            return null;
        }
      }}
    </Modal>
  );
}
